<template>
  <div class="restricted-content-wrapper">
    <div class="restricted-content-wrapper-inner upgrade-layout-default">
      <b-container>
        <b-row>
          <b-col
            class="title restricted-content-title"
          >
            <span class="restricted-content-icon">&nbsp;</span>
            <h3>{{ title }}</h3>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="6"
            class="login"
          >
            <div class="login-inner">
              <strong>Login to your Account</strong>
              <login-subform />
            </div>
          </b-col>
          <b-col
            :cols="colSize"
            class="signup-cta"
          >
            <div class="content-inner">
              <div v-html="content" />
              <template v-if="join || link">
                <span class="links">
                  <a
                    v-if="join"
                    :href="join"
                    class="join-link css-button"
                  >Join now</a>
                  <a
                    v-if="link"
                    :href="link"
                    class="btn btn-learn-more learn-more"
                  >Learn more</a>
                </span>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: function() {
        return this.$store.getters['node/getByPath'](this.$route.path)
      }
    }
  },
  data: function() {
    return {
      loggedIn: false
    }
  },
  computed: {
    title: function() {
      return 'This content is private you must Subscribe or Become a Full Member to keep on reading'
    },
    isNotLoggedIn: function() {
      return (!this.$store.getters['user/isLoggedIn'])
    },
    colSize: function() {
      return (this.isNotLoggedIn ? '12' : '6')
    },
    content: function() {
      return '<p><strong>Subscribe for Free</strong></p>' +
        '<p>Getting your web user account is fast, free and lets you get a taste of the great content and resources available to our members.</p><ul>' +
        '<li>Access more articles and resources</li>' +
        '<li>Subscribe to special interest groups to get content tailored to you</li>' +
        '<li>Buy event tickets online</li>' +
        '</ul>'
    },
    join: function() {
      return 'join'
    },
    link: function() {
      return 'link'
    }
  }
}
</script>

<style>

.restricted-content-wrapper {
  border: 2px solid;
  border-color: #E9E9E9;
  display: inline-block;
  width: 100%;
  padding: 1em;
  margin: 1em 0em
}

.restricted-content-wrapper .restricted-content-icon {
  display: none
}

.restricted-content-wrapper .login,.restricted-content-wrapper .signup-cta {
  margin-bottom: 1em
}

.restricted-content-wrapper .login .form-submit,.restricted-content-wrapper .login .join-link,.restricted-content-wrapper .signup-cta .form-submit,.restricted-content-wrapper .signup-cta .join-link {
  width: 100%;
  margin-bottom: .5em
}

.restricted-content-wrapper .join-link {
  display: inline-block;
  color: #fff;
  text-align: center;
  text-decoration: none;
  padding: 0.6em 1.2em;
  background: #68B75B;
  border: 0 none;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px
}
</style>
